import { msg } from '@lingui/core/macro';

export const SHARED_RANKS_CUSTOM_RENDER_SELECT_ALL = msg`Select All`;
export const SHARED_RANKS_CUSTOM_RENDER_CLEAR_ALL = msg`Clear All`;
export const SHARED_RANKS_CUSTOM_RENDER_CANCEL = msg`Cancel`;
export const SHARED_RANKS_CUSTOM_RENDER_DONE = msg`Done`;
export const SHARED_RANKS_CUSTOM_RENDER_NO_SUBTYPES_FOUND = msg`No subtypes match your search`;
export const SHARED_RANKS_CUSTOM_RENDER_INFO_TEXT = msg`Scope cannot be expanded after activation. Only removal is allowed.`;
